<template>
    <div class="container">
        <div class="row" v-if="!this.loading">
            <div class="col-md-6">
                <h2>{{title}}</h2> 
                <h5>Force</h5>
            </div>
        </div> 
        <div class="row mt-4" v-if="!this.loading">
            <div class="col col-md-12 border-top border-bottom py-4 " v-if="deletable">
                <h3>Are you sure you want to delete Force: {{ name }} ?</h3> 
                <div class="form-group row">
                    <div class="col-sm-12 mt-2">
                        <button @click.prevent="destroy" class="btn btn-danger">YES</button> <router-link :to="{name:'forces.index'}" class="btn btn-light">NO</router-link>
                    </div>
                </div>
            </div>
            <div class="col col-md-12 border-top border-bottom py-4 " v-else>
                <h3>Force in use, it is not possible to delete : {{name}}</h3>
                <router-link :to="{name:'forces.index'}" class="mt-4">Back to List</router-link>
            </div>
        </div>

        <div class="row d-flex justify-content-center" v-else>
                <div class="spinner-border text-primary" style="margin-top:4rem; margin-bottom:4rem; width: 4rem; height: 4rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
        </div>
    </div>
</template>

<script>
import ForcesService from '../../../services/ForcesService'
export default {
    props: {
        id: {
            default: null,
        },
    },

    data(){
        return {
            loading: true,
            deletable: false,
            name: '',
        }
    },

    mounted(){
        this.load();
    },

    methods: {
        destroy: function () {
            ForcesService.destroy(this.id)
                .then(res => this.success(res));
        },
        success: function (res) {
            window.flash(res.data.message);
            this.$router.push({name:'forces.index'});
        },
        load: function () {
            this.loading = true;
            ForcesService.canDelete(this.id)
                .then( res => this.init(res));
        },
        init: function (res) {
            this.loading = false;
            this.deletable = res.data.deletable;
            this.name = res.data.data.name;
        },
    },

    computed: {
        title: function () {
            return this.deletable ? 'Delete' : 'Cannot Delete';
        }
    },
}
</script>
